import h5 from './h5.svg'
import h2 from './h2.svg'
import h5t from './h5t.svg'
import h5l from './h5l.svg'
import h5e from './h5e.svg'
import gc from './gc.svg'
import video from './video.svg'

export default {
  h5,
  h2,
  h5t,
  h5l,
  h5e,
  gc,
  video
}
